import React, { useState, useEffect } from 'react';
import { PieChart, Pie, Cell, Tooltip, LineChart, Line, XAxis, YAxis, CartesianGrid, Legend, BarChart, Bar, } from 'recharts';
import { useNavigate } from 'react-router-dom';
const Home = ({ jobs, applications }) => {
    const navigate = useNavigate();
    // const [filteredJobs, setFilteredJobs] = useState(jobs);
    const [selectedJobId, setSelectedJobId] = useState('');
    console.log(jobs)
    const COLORS = ['#c5baaa', '#806d61', '#ee7828', '#2c2c2c'];
    const applicationsData = [
        { month: 'Jan', applications: 50 },
        { month: 'Feb', applications: 75 },
        { month: 'Mar', applications: 60 },
        { month: 'Apr', applications: 90 },
    ];
    const pieData = [
        { name: 'Applications', value: 400 },
        { name: 'Jobs Posted', value: 300 },
        { name: 'Hires', value: 200 },
        { name: 'Archived Jobs', value: 100 },
    ];

    const lineData = [
        { date: '2024-01-01', applications: 10 },
        { date: '2024-01-05', applications: 15 },
        { date: '2024-01-10', applications: 25 },
        { date: '2024-01-15', applications: 18 },
        { date: '2024-01-20', applications: 30 },
        { date: '2024-01-25', applications: 22 },
        { date: '2024-01-30', applications: 35 },
    ];

    const sortedJobs = [...jobs].sort((a, b) => b.views - a.views);
    const topJobs = sortedJobs.slice(0, 5).map((job) => ({
        id: job._id,
        title: job.title,
        views: job.views,
    }));
    // const topJobs = [
    //     { id: 1, title: 'Software Engineer', views: 150 },
    //     { id: 2, title: 'Data Analyst', views: 120 },
    //     { id: 3, title: 'Product Manager', views: 110 },
    //     { id: 4, title: 'UI/UX Designer', views: 90 },
    //     { id: 5, title: 'Marketing Specialist', views: 80 },
    // ];

    const otherInfo = {
        totalUsers: 500,
        averageApplicationTime: '3 days',
        activeJobs: 50,
    };
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredJobs, setFilteredJobs] = useState(jobs);

    const handleSearch = (event) => {
        const term = event.target.value;
        setSearchTerm(term);

        const filtered = jobs.filter(job => {
            const searchString = `${job.title} ${job.description} ${job.category} ${job.location} ${job.department} ${job.experienceLevel}`.toLowerCase();
            return searchString.includes(term.toLowerCase());
        });
        setFilteredJobs(filtered);
    };
    const handleJobSelect = (event) => {
        setSelectedJobId(event.target.value);
        // You can add logic here to navigate or display job details based on the selected job ID
        console.log("Selected Job ID:", event.target.value);
      };
    return (
        <div className="grid grid-cols-1 gap-6">
            {/* Search Bar */}
            <div className="flex justify-between items-center">
                <input
                    type="text"
                    placeholder="Search jobs..."
                    className="w-2/3 p-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#ee7828]"
                    value={searchTerm}
                    onChange={handleSearch}
                />



                <button
                    className="bg-[#ee7828] text-white px-4 py-2 rounded-lg shadow hover:bg-[#d96c23]"
                    onClick={() => navigate('/dashboard?section=postJob')}
                >
                    Post a Job
                </button>
            </div>

                      
            {/* Analytics Grid */}
            <div className="grid grid-cols-1 md:grid-cols-[55%_45%] gap-6">
                {/* Pie Chart */}
                <div className="bg-white rounded-lg shadow-md p-4">
                    <h2 className="text-lg font-bold text-[#2c2c2c] mb-4">Analytics</h2>
                    <PieChart width={500} height={300}>
                        <Pie
                            data={pieData}
                            cx="50%"
                            cy="50%"
                            labelLine={false}
                            label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                            outerRadius={100}
                            fill="#8884d8"
                            dataKey="value"
                        >
                            {pieData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip />
                    </PieChart>
                </div>

                {/* Line Chart */}
                <div className="bg-white rounded-lg shadow-md p-4">
                    <h2 className="text-lg font-bold text-[#2c2c2c] mb-4">New Applications Over Time</h2>
                    <LineChart width={400} height={300} data={lineData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Line type="monotone" dataKey="applications" stroke="#8884d8" activeDot={{ r: 8 }} />
                    </LineChart>
                </div>

                {/* Top Viewed Jobs */}
                <div className="bg-white rounded-lg shadow-md p-4">
                    <h2 className="text-lg font-bold text-[#2c2c2c] mb-4">Top 5 Most Viewed Jobs</h2>
                    <table className="w-full">
                        <thead>
                            <tr>
                                <th className="text-left py-3">#</th>
                                <th className="text-left py-3">Job Title</th>
                                <th className="text-left py-3">Views</th>
                                <th className="text-left py-3">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {topJobs.map((job, index) => (
                                <tr key={job.id} className="border-b border-gray-200">
                                    <td className="py-3">{index + 1}</td>
                                    <td className="py-3">
                                        <div className="font-semibold">{job.title}</div>
                                        <div className="text-xs font-light text-gray-600">{job.id}</div>
                                    </td>
                                    <td className="py-3">{job.views}</td>
                                    <td className="py-3">
                                        <button
                                            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded text-sm"
                                            onClick={() => {
                                                // Implement view job functionality here
                                                console.log(`View job: ${job.id}`);
                                                // Example: Navigate to job details page
                                                // window.location.href = `/job/${job.id}`;
                                            }}
                                        >
                                            View
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Other Info */}
                <div className="bg-white rounded-lg shadow-md p-4">
                    <h2 className="text-lg font-bold text-[#2c2c2c] mb-4">Applications Over Last 4 Months</h2>
                    <BarChart width={400} height={300} data={applicationsData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="month" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="applications" fill="#8884d8" />
                    </BarChart>
                </div>
            </div>
        </div>
    );
};

export default Home;